module.exports = __webpack_public_path__ + "static/media/08.111.85687847.webp";